/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { findElement as e, matchesClasses as t, matchesNodeName as o } from "./dom-queries.mjs";
const s = "k-grid-header", i = "k-grid-footer", h = "TABLE", a = o(h);
class c {
  constructor(r) {
    this.element = r, this.list = e(r, t("k-grid"));
  }
  content() {
    return e(this.list, t("k-grid"));
  }
  header() {
    return this.headerWrap = this.headerWrap || e(this.element, t(s)), e(this.headerWrap, t(`${s}`));
  }
  footer() {
    return this.footerWrap = this.footerWrap || e(this.element, t(i)), e(this.footerWrap, t(`${i}`));
  }
  table() {
    return e(this.element, a);
  }
}
export {
  i as FOOTER_CLASS,
  c as GridQuery,
  s as HEADER_CLASS
};
